<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
                    <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7">
                        <div class="modal-container" @click.stop>

                            <div class="flex-header" style="justify-content: space-between;">
                                <div>
                                    <h2 class="transporter-title">{{title}}</h2>
                                </div>
                                <div>
                                    <div class="modal-close" @click="$emit('closeModal')">
                                        <i class="fal fa-times fa-2x"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="modal-body">

                                <div style="max-height:500px; max-width: 650px;">
                                    <div class="row mt-3 f-25">
                                    <div class="col-6">
                                        <label>No TO:</label>
                                    </div>
                                    <div class="col-6 wrap-text">
                                        {{data.no_to}}
                                    </div>
                                </div>

                                <div class="row mt-3 f-25">
                                    <div class="col-6">
                                        <label>Status Saat Ini:</label>
                                    </div>
                                    <div class="col-6">
                                        {{data.status_validasi}}
                                    </div>
                                </div>

                                <div class="row mt-3 f-25">
                                    <div class="col-6">
                                        <label>Tanggal Validasi</label>
                                    </div>
                                    <div class="col-6">
                                        <!-- <flat-pickr
                                            :config="rangePickr"
                                            placeholder="Select Date"
                                            v-model="selected.date"
                                            style="font: normal normal normal 12px/18px Poppins;"
                                        ></flat-pickr> -->
                                        {{data.tanggal_dokumen}}
                                    </div>
                                </div>

                                <div class="row mt-3 f-25">
                                    <div class="col-6">
                                        <label>Perubahan Status:</label>
                                    </div>
                                    <div class="col-6">
                                        <Multiselect 
                                            :options="options.statusChange.map(x => x.var)"
                                            :custom-label="opt => options.statusChange.find(x => x.var == opt).name"
                                            :allow-empty="false"
                                            v-model="statusChange"
                                        />
                                    </div>
                                </div>

                                <div class="row mt-5 f-25">
                                    <div class="col-6">
                                        <button 
                                            class="w-100 btn border rounded"
                                            @click="$emit('closeModal')"
                                            style="
                                                background-color: white;
                                                color: #1B698E;
                                                border: 1px solid #1B698E!important;"
                                        >
                                            Batal
                                        </button>
                                    </div>
                                    <div class="col-6">
                                        <button 
                                            class="w-100 btn rounded"
                                            @click="processData"
                                            style="
                                                background-color: #1B698E;
                                                color: white;"
                                        >
                                            Ubah Status
                                        </button>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
    props : ['data' , 'title'],
    components : {
        Multiselect
    },
    data () {
        let today = new moment().format('Y-MM-D')
        return {
            statusChange : null,
            options : {
                statusChange : [{
                    name : 'Validasi',
                    var : 0
                },{
                    name : 'Posting',
                    var : 1
                }]
            },
            rangePickr: {
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d-m-Y",
                altInputClass: 'form-control input elegant-flatpickr'
            },
            selected : {
                date : today
            }
        }
    },
    mounted () {
        this.statusChange = this.options.statusChange.find(x => x.name == this.data.status_validasi).var
    },
    methods : {
        processData () {
            let data = {
                status : this.statusChange,
                no_to : this.data.no_to,
                nopol : this.data.nopol,
                // tanggal : this.data.tanggal_dokumen
            }

            this.$http.put('/api/validation/updateDocument' , data)
            .then(() => {
                this.$emit('updateTable')
                this.$emit('closeModal')
            })
            .catch((err) => {
                let message = 'Gagal mengubah status TO.'

                if (err.response && err.response.data) {
                    message = err.response.data.message || err.response.data.error || message
                }

                this.$swal.fire({
                    title : 'Error',
                    text : message,
                    icon : 'error'
                })
            })
        }
    }
}
</script>

<style scoped>
    .flex-header{
        display: flex;
    }

    .f-25 {
        font-size: 18px;    
    }

    .wrap-text {
        word-wrap: break-word;
    }

    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        /* padding: 20px 30px; */
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        padding: 40px 40px 20px;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    /* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
    input {
        outline: none;
        margin: 0;
        border: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        width: 100%;
        font-size: 14px;
        font-family: inherit;
    }

    .input--style-4 {
        line-height: 50px;
        background: #fafafa;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        padding: 0 20px;
        font-size: 16px;
        color: #666;
        -webkit-transition: all 0.4s ease;
        -o-transition: all 0.4s ease;
        -moz-transition: all 0.4s ease;
        transition: all 0.4s ease;
    }

    .input--style-4::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #666;
    }

    .input--style-4:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #666;
        opacity: 1;
    }

    .input--style-4::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #666;
        opacity: 1;
    }

    .input--style-4:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #666;
    }

    .input--style-4:-ms-input-placeholder {
        /* Microsoft Edge */
        color: #666;
    }

    .label {
        font-size: 16px;
        color: #555;
        text-transform: capitalize;
        display: block;
        margin-bottom: 5px;
    }

    .radio-container {
        display: inline-block;
        position: relative;
        padding-left: 30px;
        cursor: pointer;
        font-size: 16px;
        color: #666;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .radio-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .radio-container input:checked~.checkmark {
        background-color: #e5e5e5;
    }

    .radio-container input:checked~.checkmark:after {
        display: block;
    }

    .radio-container .checkmark:after {
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 12px;
        height: 12px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        background: #57b846;
    }

    .checkmark {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #e5e5e5;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .input-group {
        position: relative;
        /* margin-bottom: 22px; */
        padding: 20px;
    }

    .input-group-icon {
        position: relative;
    }

    .input-icon {
        position: absolute;
        font-size: 18px;
        color: #999;
        right: 18px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
    }

    /* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
    .title {
        font-size: 40px;
        color: #525252;
        /* margin-bottom: 40px; */
        text-align: center;
    }

    .transporter-title {
        font-family: 'Poppins';
        font-size: 20px;
        font-weight: medium;

        padding: 20px 25px;
        margin: 0;
    }

    .sub--title {
        color: red;
        margin-bottom: 40px;
        text-align: center;
    }
  
    
    .center{
        text-align: center;
    }
    .left{
        text-align: left;
    }
    .right{
        text-align: right;
    }
    
    .outerBox{
        padding: 0 20px;
    }
    .innerBox{
        padding: 0.8em 1.5em;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 5px #E0E0E0;
    }
    .paddingInnerInnerBox{
        padding:10px 15px;
    }
    .outerBoxPass{
        padding: 20px;
    }
    .innerBoxPass{
        border:1px solid #BDBDBD;
        border-radius:5px;
        box-shadow: 10px 10px 20px #E0E0E0;
    }
    .innerBoxPass>.row:first-child{
        cursor: pointer;
    }
    .paddingInnerInnerBox p{
        margin: 0;
    }
    .subPartTitle{
        font-size: 110%;
        padding: 6px 12px;
        color: #757575;
    }
    .collapsed:hover{
        text-decoration: underline;
    }
    .collapseButton{
        color: black;
    }

    .modal-close {
        background-color: #F2F2F2;
        color: black;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        border-top-right-radius: 8px;

        cursor: pointer;
        transition: background-color .3s ease;
    }

    .modal-close:hover {
        background-color: #E0E0E0;
    }

    .input--style-4:disabled {
        background: #cfcfcf;
    }

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

    .innerBox {
        padding: 0.8em 1.5em;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 5px #E0E0E0;
    }

    .hoverable:hover {
        cursor: pointer;
    }
</style>
